import React, { Component } from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify'
import { getCarimbo } from '../../actions';

class ModalHistorico extends Component {

    
    constructor() {
        super()
        this.state = {
            modalIsOpen: true,
        }

        this.closeModal = this.closeModal.bind(this)
    }

    closeModal(){
        this.props.closeModal()
    }

    returnStatus(doc){
        var frase = 'Em processo até ' + doc.dataLimite
        var color = 'warning'
        
        switch(doc.status){
            case 'finalizado':
                frase = doc.status
                color = 'success'
            break;
            case 'cancelado':
                frase = doc.status
                color = 'danger'
            break;
        }

        return (
            <p className={`badge badge badge-${color}`}>{frase}</p>
        )
    }

    downloadDoc() {
        
        const { documento } = this.props.documentos

        this.props.getCarimbo(documento.id, success => {
            const { error_doc } = this.props.documentos

            if(!success) {
                // toast.error(error_doc)
                toast.success('Aguarde, seu download iniciará em breve')
                this.props.carimboErrorHandler(documento)
            }
            else toast.success('Download iniciará em breve!')
        }, true)       

    }

    render(){
        const {loading_gerar_carimbo} = this.props
        const { documento, load_carimbo } = this.props.documentos
        const docFinalizado = (documento.status || '').toLowerCase().includes('finalizado')
        return (
            // <Modal
            //     isOpen={this.state.modalIsOpen}
            //     onRequestClose={this.closeModal}
            //     ariaHideApp={false}
            //     style={customStyles.modal}>
            <div className="modal fade" id="modalLog" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div className="modal-dialog" role="document">

                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Histórico</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body ">

                        <div className="container text-left">
                            <div className="row">
                                <div className="col">
                                    <h5>Eventos</h5>
                                    <small className="text-muted">Histórico dos eventos ocorridos no documento</small>

                                    <ul className="timeline ">

                                        {documento.historicos != undefined
                                            ?documento.historicos.map( (v, i) => {
                                                const date = v.created_at.split('-')
                                                return (
                                                    <li key={i}>
                                                        <h6>{date[0]}<small className="text-muted">{date[1]}</small></h6>
                                                        {/* <span className="badge badge-pill badge-success">Assinado</span> */}
                                                        {/* {this.returnStatus(documento)} */}
                                                        <p style={{overflowWrap:'break-word'}}> {v.descricao}</p>
                                                    </li>
                                                )
                                            })
                                            :null
                                        }
                      
                                    </ul>

                                    <div className="mt-3">

                                        <h5 className="mt-3">Notificações enviados</h5>
                                        <small className="text-muted">Histórico das notificações enviadas por e-mail ou sms</small>

                                        {
                                            documento.notificacoes && documento.notificacoes != undefined && documento.notificacoes.map( (noti, index) => {
                                                const date = noti.created_at.split('-')
                                                return(
                                                    <div style={{ wordWrap: 'break-word'}} key={'noti'+index} className="row border border-gray rounded mt-3 p-3 no-gutters">
                                                        <div className="col">
                                                            {date[0]}
                                                            <br />
                                                            <small className="text-muted"> {date[1]}</small>
                                                        </div>
                                                        <div className="col">
                                                           {noti.descricao}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="modal-footer" style={{ display:'flex', alignItems:'center'}}>
                        {docFinalizado && <button  id="downloadDoc" type="button" className="btn btn-dark"
                            onClick={() => this.downloadDoc('carimbo')} disabled={load_carimbo || loading_gerar_carimbo}>
                            {(load_carimbo || loading_gerar_carimbo)?<span style={{marginRight:10}} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>:null}
                            Baixar Carimbo
                        </button>}

                        <button type="button" className="btn btn-danger" data-dismiss="modal">Fechar</button>

                    </div>
                </div>
            {/* </Modal> */}
            </div>
            {/* <ToastContainer autoClose={3000} position={toast.POSITION.BOTTOM_CENTER} draggable={false}/> */}
        </div>

        )
    }
}

const mapStateToProps = ({ documentos }) => {
    return {
        documentos
    }
}

export default connect(mapStateToProps, {
    getCarimbo
})(ModalHistorico);

const customStyles = {
    main: {
        paddingLeft: '2%',
        paddingRight: '2%'
    },
    modal:{
        width:'50%',
        // height: '50%',
        left:'35%',
        top: '80px',
    }
}